// extracted by css-extract-rspack-plugin
export default {"triangle":"SyncHrMasterModal__triangle--kxp76","syncButton":"SyncHrMasterModal__syncButton--CLxJm"};